import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Inbox, Mail, Phone, Calendar } from 'lucide-react';
import api from '../../lib/adminApi';

const EnquiriesManager = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get('/api/partners/enquiries')
      .then((res) => setItems(res.data))
      .catch((err) => { console.error('Failed to load enquiries:', err); setItems([]); });
  }, []);

  if (items === null) return <p className="text-sm text-[#757B7F]">Loading enquiries...</p>;

  return (
    <div data-testid="enquiries-manager">
      <div className="flex items-baseline justify-between mb-6">
        <h2 className="text-2xl" style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }}>Vendor Enquiries</h2>
        <span className="text-xs text-[#757B7F]" data-testid="enquiries-count">{items.length} total</span>
      </div>

      {items.length === 0 ? (
        <div className="bg-white border border-[#E6E2DC]/60 rounded-xl p-12 text-center text-[#757B7F] text-sm" data-testid="enquiries-empty">
          <Inbox size={28} className="mx-auto mb-3 text-[#DE92A9]" />
          No enquiries yet. Couples can contact partners from each partner profile page.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((e) => (
            <div key={e.id} className="bg-white border border-[#E6E2DC]/60 rounded-xl p-5" data-testid={`enquiry-${e.id}`}>
              <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
                <div>
                  <Link to={`/partners/${e.partner_slug}`} target="_blank" className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#DE92A9] hover:underline">
                    {e.partner_name}
                  </Link>
                  <p className="text-lg text-[#2C2C2C]" style={{ fontFamily: '"Playfair Display", serif' }}>{e.name}</p>
                </div>
                <span className="text-xs text-[#757B7F]">{new Date(e.created_at).toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' })}</span>
              </div>
              <div className="flex flex-wrap gap-4 text-xs text-[#5A5A5A] mb-3">
                <a href={`mailto:${e.email}`} className="inline-flex items-center gap-1 hover:text-[#DE92A9]"><Mail size={12} /> {e.email}</a>
                {e.phone && <span className="inline-flex items-center gap-1"><Phone size={12} /> {e.phone}</span>}
                {e.wedding_date && <span className="inline-flex items-center gap-1"><Calendar size={12} /> {e.wedding_date}</span>}
              </div>
              <p className="text-sm text-[#5A5A5A] whitespace-pre-wrap bg-[#FAF9F7] rounded-lg p-3">{e.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EnquiriesManager;
